/*
import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalNextProvider } from '@jutro/components';
import {
    WizardPage,
    wizardProps,
    WizardPageTemplate,
    WizardPageTemplateWithTitle
} from 'gw-portals-wizard-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { TranslatorContext } from '@jutro/locale';
import {Claim, FNOLLossLocation} from 'gw-capability-fnol-common-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withRouter } from 'react-router-dom';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { messages as commonMessages } from 'gw-platform-translations';
import metadata from './WhatPage.metadata.json5';
import messages from '../../FNOLFA.messages';
import wizardConfig from '../../config/fnol-fa-wizard-cofig.json5';
import styles from "./WhatPage.module.scss";

function FNOLFAWhatPage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        changeNextSteps,
        history,
        history: {
            location: { state = {} }
        },
        authHeader
    } = props;
    const { steps: wizardSteps } = wizardConfig;
    const [isLoading, setIsLoading] = useState(false);
    const { FNOLService } = useDependencies('FNOLService');
    const [pageData] = useState(state);
    const translator = useContext(TranslatorContext);
    const [liabilityAndPRTypeCodes, updateLiabilityAndPRTypeCodes] = useState([]);
    const [glTypeCodes, updateGLTypeCodes] = useState([]);
    const [prTypeCodes, updatePRTypeCodes] = useState([]);
    const lossCauseTypesArray = claimVM.lossCause.aspects.availableValues;
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        registerInitialComponentValidation
    } = useValidation('FNOLFAWhatPage');

    const getLossCause = useCallback(
        (selectedLossCause) => {
            const LossCause = _.find(lossCauseTypesArray, (cause) => {
                return cause.code === selectedLossCause;
            });
            _.set(claimVM, 'lossCause.value', LossCause);
            updateWizardData(claimVM);
        },
        [claimVM, lossCauseTypesArray, updateWizardData]
    );

    const isClaimStatus = useCallback(() => {
        const { claimStatus } = pageData;
        return !_.isEmpty(claimStatus);
    }, [pageData]);

    useEffect(() => {
        registerInitialComponentValidation(isClaimStatus);
    }, [registerInitialComponentValidation, isClaimStatus]);


    useEffect(() => {
        const detailsGLAndPRClaimTypeCodes = _.filter(
            claimVM.lossType.aspects.availableValues,
            (typeCode) => {
                const excludeClaimTypeCodesList = [
                    'AUTO',
                    'TRAV',
                    'WC'
                ];
                return excludeClaimTypeCodesList.indexOf(typeCode.code) === -1;
            }
        ).map((claimTypeObj) => {
            return {
                code: claimTypeObj.code,
                name: translator({
                    id: claimTypeObj.name,
                    defaultMessage: claimTypeObj.name
                })
            };
        });

        const detailsGLFarmLoss = claimVM.glfarmLossCause.aspects.availableValues.map((typeObj) => {
            return {
                code: typeObj.code,
                name: translator({
                    id: typeObj.name,
                    defaultMessage: typeObj.name
                })
            };
        });

        const detailsPRFarmLoss = claimVM.prfarmLossCause.aspects.availableValues.map((typeObj) => {
            return {
                code: typeObj.code,
                name: translator({
                    id: typeObj.name,
                    defaultMessage: typeObj.name
                })
            };
        })
        updateLiabilityAndPRTypeCodes(detailsGLAndPRClaimTypeCodes);
        updateGLTypeCodes(detailsGLFarmLoss);
        updatePRTypeCodes(detailsPRFarmLoss);
        // It should call once when page is rendered
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onHandleClaimTypeChange = (value, path) => {
        _.set(claimVM, path, value);
        updateWizardData(claimVM);
    };

   /!* const redirectContactAgent = useCallback(() => {
        const { redirectPath } = pageData;
        const claimNumber = _.get(claimVM.value, 'claimNumber');
        return history.push({
            pathname: `/contact-agent/${claimNumber}`,
            state: {
                redirectPath: redirectPath
            }
        });
    }, [claimVM.value, history, pageData]);*!/

    /!*const onNext = useCallback(() => {
        let miscellaneous = claimVM.lossCause.value.code === 'otherobjcoll';
        const policyNumber = _.get(claimVM.value, 'policy.policyNumber');
        const isClaimNumberAvailable = _.get(claimVM.value, 'claimNumber');
        if (isClaimNumberAvailable) {
            if (miscellaneous) {
                return redirectContactAgent();
            }
            return incidentPageHandling();
        }
        setIsLoading(true);
        return FNOLService.getFNOLDetails(policyNumber, claimVM.value, authHeader)
            .then((response) => {
                claimVM.value = new Claim(response);
                miscellaneous = claimVM.lossCause.value.code === 'otherobjcoll';
                if (miscellaneous) {
                    return redirectContactAgent();
                }
                return incidentPageHandling();
            })
            .catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.caCreateDraftErrorTitle,
                    message: messages.caCreateDraftErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [FNOLService, authHeader, claimVM, incidentPageHandling, redirectContactAgent]);*!/

   /!* const getIncidentTypeRadioButtonValue = useCallback(() => {
        const lossCause = _.get(claimVM.value, 'lossCause');
        const isCollisionSelected = !!_.find(collisionTypeCodes, {
            code: lossCause
        });
        return isCollisionSelected ? 'collision' : lossCause;
    }, [claimVM, collisionTypeCodes]);*!/

    const overrides = {
        /!*incidentTypeRadioButton: {
            value: getIncidentTypeRadioButtonValue(),
            onValueChange: getLossCause
        },*!/
        /!*whatPageLoader: {
            loaded: !isLoading,
            loadingMessage: translator(messages.caCreateDraftClaim)
        },
        claimsCaTypeOfIncidentPage: {
            visible: !isLoading
        }*!/
        whatPageLoader: {
            loaded: !isLoading,
            loadingMessage: translator(messages.caCreateDraftClaim)
        },
        typeOfClaimDropDown: {
            availableValues: liabilityAndPRTypeCodes
        },
        glfarmLossCategory: {
            visible: _.get(claimVM, 'lossType.value.code') === 'GL',
            availableValues: glTypeCodes
        },
        prfarmLossCategory: {
            visible: _.get(claimVM, 'lossType.value.code') === 'PR',
            availableValues: prTypeCodes
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onHandleClaimTypeChange: onHandleClaimTypeChange
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrides);
        },
        [claimVM, overrides]
    );

   /!* return (
        <WizardPage
            skipWhen={initialValidation}
            disableNext={!isComponentValid}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                resolveValue={readValue}
                overrideProps={overrides}
                onValidationChange={onValidate}
                onModelChange={updateWizardData}
            />
        </WizardPage>
    );*!/
    return (
        <WizardPage
            disableNext={!isComponentValid}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                resolveValue={readValue}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

FNOLFAWhatPage.propTypes = wizardProps;
/!*FNOLFAWhatPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};*!/
export default withRouter(withAuthenticationContext(FNOLFAWhatPage));
*/
import React, {
    useCallback, useEffect, useContext, useState
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './WhatPage.metadata.json5';
import styles from './WhatPage.module.scss';
import {messages} from 'gw-capability-fnol-cp-react/FNOLCP.messages';

function FNOLFAWhatPage(props) {
    const translator = useContext(TranslatorContext);
    const {
        wizardData: claimVM,
        updateWizardData,
        history: { location: { state = {} } }
    } = props;
    const {
        onValidate, isComponentValid, initialValidation, registerInitialComponentValidation
    } = useValidation('FNOLFAWhatPage');

    const [liabilityAndPRTypeCodes, updateLiabilityAndPRTypeCodes] = useState([]);
    const [glTypeCodes, updateGLTypeCodes] = useState([]);
    const [prTypeCodes, updatePRTypeCodes] = useState([]);
    //const [isLoading, setIsLoading] = useState(false);

    const onHandleClaimTypeChange = (value, path) => {
        _.set(claimVM, path, value);
        updateWizardData(claimVM);
    };

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        /*whatPageLoader: {
            loaded: !isLoading,
            loadingMessage: translator(messages.caCreateDraftClaim)
        },*/
        typeOfClaimDropDown: {
            availableValues: liabilityAndPRTypeCodes
        },
        glfarmLossCategory: {
            visible: _.get(claimVM, 'lossType.value.code') === 'GL',
            availableValues: glTypeCodes
        },
        prfarmLossCategory: {
            visible: _.get(claimVM, 'lossType.value.code') === 'PR',
            availableValues: prTypeCodes
        },
        dateOfNotice: {
            defaultValue: new Date()
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onHandleClaimTypeChange: onHandleClaimTypeChange
        }
    };

    const { claimStatus } = state;

    const validateClaimStatus = useCallback(() => {
        return !_.isEmpty(claimStatus) && claimStatus === translator({ id: 'typekey.ClaimState.draft', defaultMessage: 'Draft' });
    }, [claimStatus, translator]);

    useEffect(() => {
        registerInitialComponentValidation(validateClaimStatus);
    }, [validateClaimStatus, registerInitialComponentValidation]);

    useEffect(() => {
        const detailsGLAndPRClaimTypeCodes = _.filter(
            claimVM.lossType.aspects.availableValues,
            (typeCode) => {
                const excludeClaimTypeCodesList = [
                    'AUTO',
                    'TRAV',
                    'WC'
                ];
                return excludeClaimTypeCodesList.indexOf(typeCode.code) === -1;
            }
        ).map((claimTypeObj) => {
            return {
                code: claimTypeObj.code,
                name: translator({
                    id: claimTypeObj.name,
                    defaultMessage: claimTypeObj.name
                })
            };
        });

        const detailsGLFarmLoss = claimVM.glfarmLossCause.aspects.availableValues.map((typeObj) => {
            return {
                code: typeObj.code,
                name: translator({
                    id: typeObj.name,
                    defaultMessage: typeObj.name
                })
            };
        });

        const detailsPRFarmLoss = claimVM.prfarmLossCause.aspects.availableValues.map((typeObj) => {
            return {
                code: typeObj.code,
                name: translator({
                    id: typeObj.name,
                    defaultMessage: typeObj.name
                })
            };
        })
        updateLiabilityAndPRTypeCodes(detailsGLAndPRClaimTypeCodes);
        updateGLTypeCodes(detailsGLFarmLoss);
        updatePRTypeCodes(detailsPRFarmLoss);
        // It should call once when page is rendered
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <WizardPage
            disableNext={!isComponentValid}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

FNOLFAWhatPage.propTypes = wizardProps;
export default withRouter(FNOLFAWhatPage);

